import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Mag = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M38.19,41.28l0,4.583l-25.483,0c-3.129,-0.003 -5.704,-2.578 -5.707,-5.708c0,-0.263 0.02,-0.526 0.061,-0.788l-0.061,0l0,-32.233c0.003,-2.742 2.261,-4.997 5.003,-4.997c2.242,0 4.223,1.507 4.821,3.669l24.176,0l0,35.474l-2.81,0Zm-2.561,2.019l0,-2.021l-21.186,0l0,-1.124c-0.037,-1.312 -1.127,-2.37 -2.439,-2.37c-1.312,0 -2.402,1.058 -2.44,2.37c0.001,1.724 1.419,3.142 3.143,3.145l22.922,0Zm2.808,-34.931l-21.432,0l0,30.349l21.432,0l0,-30.349Zm-2.537,27.78l-16.341,0l0,-2.562l16.341,0l0,2.562Zm-23.897,-31.454c-1.338,0.002 -2.438,1.103 -2.439,2.44l0,28.657c1.514,-0.848 3.366,-0.848 4.879,0l0,-28.657c-0.001,-1.338 -1.102,-2.439 -2.44,-2.44Zm23.897,26.851l-16.341,0l0,-2.563l16.341,0l0,2.563Zm0.079,-4.948l-16.514,0l0,-15.817l16.514,0l0,15.817Zm-10.886,-2.557l8.323,0l0,-0.489l-3.141,-2.856l-5.182,3.345Zm-3.066,-3.914l0,2.836l4.004,-2.582l-1.882,-1.696l-2.122,1.442Zm11.389,-6.785l-11.397,0.005l0,3.686l2.345,-1.592l3.889,3.502l2.28,-1.473l2.883,2.613l0,-6.741Zm-4.84,3.76c-0.699,-0.009 -1.273,-0.582 -1.281,-1.281c0,-0.703 0.578,-1.282 1.281,-1.282c0.703,0 1.282,0.579 1.282,1.282c0,0.703 -0.579,1.281 -1.282,1.281Z" fill={fill} />
    </svg>
  );
};

Mag.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Mag.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
